import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { ArrowLeft, Play } from "lucide-react";
import Footer from "../components/Footer";

export default function Demo() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-gray-200 bg-white px-6 py-4 shadow-sm">
        <div className="max-w-6xl mx-auto flex items-center gap-6">
          <div className="logo-placeholder"></div>
          <Button variant="ghost" onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </header>

      <div className="flex-1 p-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Product Demo</h1>
            <p className="text-xl text-gray-600">See Podmixr Labs in action</p>
          </div>

          <Card className="bg-white border-gray-200 shadow-md p-8">
            <div className="aspect-video bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center mb-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Play className="w-10 h-10 text-white" />
                </div>
                <p className="text-gray-600 text-lg">Demo video coming soon!</p>
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-900">What You'll See</h2>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 font-semibold">•</span>
                  <span>How to set up your camera and microphone in seconds</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 font-semibold">•</span>
                  <span>Recording with the live teleprompter feature</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 font-semibold">•</span>
                  <span>AI-powered audio and video enhancement in action</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 font-semibold">•</span>
                  <span>Editing transcripts with natural language commands</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 font-semibold">•</span>
                  <span>Adding intros, outros, and background music</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 font-semibold">•</span>
                  <span>Exporting in multiple formats for different platforms</span>
                </li>
              </ul>

              <div className="pt-6 border-t border-gray-200">
                <p className="text-gray-600 mb-4">Ready to try it yourself?</p>
                <Button
                  onClick={() => navigate('/signup')}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Start Your Free Trial
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
}
